import type { UrlAttributeRecord, UrlAttributeScrubber } from "@dash0/sdk-web"

const sensitiveQueryParameterNames = ["capSamlToken"]

const sensitiveQueryParameterPattern = new RegExp(
	`((?:^|[?&])(?:${sensitiveQueryParameterNames.join("|")})=)[^&#]*`,
	"g",
)

const redact = (url: string): string => url.replace(sensitiveQueryParameterPattern, "$1REDACTED")

export const scrubUrlAttributes: UrlAttributeScrubber = (attributes) => {
	const scrubbed: UrlAttributeRecord = { ...attributes, "url.full": redact(attributes["url.full"]) }
	if (attributes["url.query"] !== undefined) {
		scrubbed["url.query"] = redact(attributes["url.query"])
	}
	return scrubbed
}
